import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { getAllLanguages } from './queries';

export const languageApi = createApi({
  reducerPath: ReducerPaths.LANGUAGE,
  baseQuery,
  tagTypes: ['language'],
  endpoints: (builder) => ({
    getAllLanguages: getAllLanguages(builder),
  }),
});

export const { useGetAllLanguagesQuery } = languageApi;
